import React, { useState, useEffect } from "react";
import Layout from "../components/layout/MainLayout";
import { graphql } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import { SEO } from "wmk-lib";
import Theme from "../vars/ThemeOptions";
import { Backlink, ImageOffset, Intro } from "../components/common";
import {
  Text,
  Tiles,
  Tile,
  Texts,
  SideBySide,
  rejig2020Title,
} from "../components/modules";
const ChapterModules = {
  Hero: ({ topic }) => <SideBySide layout="hero" topic={topic} />,
  Text: ({ topic }) => <Text topic={topic} />,
  Fluid: ({ topic }) => <SideBySide layout="fluid" topic={topic} />,
  Tile: ({ topic }) => <Tile topic={topic} />,
  Contained: ({ topic }) => <SideBySide layout="contained" topic={topic} />,
  Curved: ({ topic }) => <SideBySide layout="curved" topic={topic} />,
  Texts: ({ topics }) => <Texts topics={topics} />,
  Tiles: ({ topics, chapter }) => <Tiles topics={topics} chapter={chapter} />,
};

export default ({ data }) => {
  const [chapterTopics, setChapterTopics] = useState([]);
  const { chapter } = data;
  const { topics, subText, pdf } = chapter;
  const { json } = subText ? subText : { json: null };
  const { mainImage, ogImage, twitterImage } = chapter;
  //const { fluid } = mainImage ? mainImage : { fluid: null };
  const { fixed } = mainImage ? mainImage : { fixed: null };
  useEffect(() => {
    // set up a variable to hold a modified array of topics
    const _topics = [];
    // copy array of topics
    const xTopics = [...topics];
    xTopics.forEach((topic, i) => {
      const { ctaLayout } = topic;
      const canPair = (ctaLayout) => {
        return ctaLayout === "Tile" || ctaLayout === "Text";
      };
      const checkNext = (topics, i) => {
        if (i < topics.length - 1) {
          const current = topics[i];
          const next = topics[i + 1];
          const curType = current.ctaLayout;
          const nextType = next.ctaLayout;
          return curType && nextType && curType === nextType;
        }
        return false;
      };
      if (canPair(ctaLayout)) {
        if (checkNext(xTopics, i)) {
          _topics.push({
            ctaLayout: xTopics[i].ctaLayout + "s",
            topics: [xTopics[i], xTopics[i + 1]],
          });
          xTopics.splice(i + 1, 1);
        } else {
          _topics.push(topic);
        }
      } else {
        _topics.push(topic);
      }
      setChapterTopics(_topics);
    });
  }, [topics]);

  return (
    <Layout pageType={"chapters"} slug={chapter.slug}>
      <SEO.Meta
        title={rejig2020Title(chapter.title)}
        slug={chapter.slug}
        baseUrl={Theme.paths.protocol + "://" + Theme.paths.baseUrl}
        siteTitle={"Texas Health"}
        ogImage={
          ogImage && ogImage.fixed && ogImage.fixed.src
            ? "https:" + ogImage.fixed.src
            : undefined
        }
        twitterImage={
          twitterImage && twitterImage.fixed && twitterImage.fixed.src
            ? "https:" + twitterImage.fixed.src
            : undefined
        }
        twitterHandle={"@texashealth"}
      />
      <Container>
        <Row>
          <Col>
            <Intro title={chapter.title} json={json} backlink="/" />
          </Col>
        </Row>
      </Container>

      {/* {fluid && (
        <ImageOffset
          fluid={fluid}
          alt={mainImage.title}
          cta={{
            pdf,
            title: chapter.title,
          }}
        />
      )} */}
      {fixed && (
        <ImageOffset
          fixed={fixed}
          alt={mainImage.title}
          cta={{
            pdf,
            title: chapter.title,
          }}
        />
      )}
      {chapterTopics.map((topic, i) => {
        // if (typeof topic === "array") {
        //   console.log("multi");
        //   return null;
        // } else {
        const { ctaLayout, title } = topic;
        const JSX = ChapterModules[ctaLayout];
        return JSX ? (
          <JSX
            topic={topic}
            topics={chapterTopics[i].topics}
            chapter={chapter.slug}
            key={ctaLayout + title + i}
          />
        ) : (
          <strong key={"error" + ctaLayout + i}>NO: {ctaLayout}</strong>
        );
        // }
      })}
      <Container>
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "2.5vh",
            }}
          >
            <Backlink to={"/"}>Back to Main</Backlink>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query chapterQuery($slug: String!) {
    chapter: contentfulChapters(slug: { eq: $slug }) {
      ...NodeChaptersFields
      ogImage: mainImage {
        fixed(width: 1200, height: 630, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
      twitterImage: mainImage {
        fixed(width: 876, height: 438, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
    }
  }
`;
